import { useNavigate } from 'react-router-dom';
import { Box, SxProps, Theme } from '@mui/material';
import { CardContent } from './ReportSample.styles';
import { forwardRef } from 'react';

export const CardWrapper = forwardRef<
  HTMLDivElement,
  {
    isSelected: boolean;
    expanded?: boolean;
    children: React.ReactNode;
    isEditing: boolean;
    to: string;
    sx?: SxProps<Theme>;
    onContextMenu?: (event: React.MouseEvent) => void;
  }
>(({ isSelected, expanded, children, isEditing, to, sx, onContextMenu }, reference) => {
  const navigate = useNavigate();

  return (
    <Box
      ref={reference}
      onClick={() => {
        if (!isEditing) {
          navigate(to);
        }
      }}
      onContextMenu={onContextMenu}
      sx={{
        flex: 1,
        minWidth: 0,
        cursor: isEditing ? 'default' : 'pointer',
        paddingTop: '2px',
        paddingBottom: '2px',
        ...sx,
      }}
    >
      <CardContent selected={isSelected} expanded={expanded}>
        {children}
      </CardContent>
    </Box>
  );
});

CardWrapper.displayName = 'CardWrapper';
